import { Modal, ModalHeading } from "@sainsburys-tech/luna-modal";
import { useState } from "react";
import { Link } from "@sainsburys-tech/luna-link";
import { More } from "@sainsburys-tech/luna-icons";

export const InformationPopup = (props: any) => {
  const [isOpen, setIsOpen] = useState(false);
  return (
    <>
      {props.dataPage===""?<Link onClick={() => setIsOpen(true)} data-testid="info-link">{props.linkText}</Link>:
       <><span data-testid="initial-value">{props.initialValue}</span><More size="large" onClick={() => setIsOpen(true)} className="customColor" style={{color:""}} data-testid="ln-c-icon">{props.linkText} </More></>}

      {isOpen && (
        <Modal
          handleClose={() => setIsOpen(false)}
          open={isOpen}
          headingId="info-modal"
          closeElement="Close"
          className="infoModal"
          stickyHeader="Sticky Header"
          data-testid="modal"
        >
          <ModalHeading element="h5" data-testid="modal-heading">{props.modalHeading}</ModalHeading>
          {props.children}
        </Modal>
      )}
    </>
  );
};
